// extracted by mini-css-extract-plugin
module.exports = {"ResourcePage":"ResourcePage_ResourcePage__3YBLN","Header":"ResourcePage_Header__1VXED","ResourceList":"ResourcePage_ResourceList__1JRhD","DemoList":"ResourcePage_DemoList__3zG-R"};